import { instance } from '../instance'

/**
 *
 * @param [uuid] - (Optional) Generated uuid for the beneficiary.
 * @param name
 * @param currency_id
 * @param bank_country
 * @param iban
 * @param bic_swift
 * @param account_number
 * @param sort_code
 * @param bank_details_type
 * @param street
 * @param house
 * @param city
 * @param country_id
 * @param postal_code
 * @param entity_type
 * @param company_name
 * @param first_name
 * @param last_name
 * @param validate
 * @return {Promise<AxiosResponse<any>>}
 */
export const addBeneficiary = async (
  {
    uuid,
    name,
    currency_id,
    bank_country,
    iban,
    bic_swift,
    account_number,
    sort_code,
    bank_details_type,
    street,
    house,
    city,
    country_id,
    postal_code,
    entity_type,
    company_name,
    first_name,
    last_name,
  },
  { validate },
) => {
  return instance.post(
    '/v2/beneficiary',
    {
      uuid,
      name,
      currency_id,
      bank_country,
      iban,
      bic_swift,
      account_number,
      sort_code,
      bank_details_type,
      street,
      house,
      city,
      country_id,
      postal_code,
      entity_type,
      company_name,
      first_name,
      last_name,
    },
    {
      params: {
        validate: Number(validate),
      },
    },
  )
}
